var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnbdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.133 5.342 3.155 1.822 4.835-2.796 5.029 2.903 2.88-1.687L16.097 1 8.133 5.342zM3 8.426l3.016-1.808 2.958 1.708-2.917 1.865-.043 3.263-2.958-1.708L3 8.426zM16.17 9.982l-2.96-1.708 3.001-1.554 2.812 1.622-2.853 1.64zm12.987 1.838L29.1 8.304l-2.903-1.611L23.24 8.4l2.803 1.668.156 3.46 2.957-1.708zm-5.031 5.403-2.958 1.707-.007 3.29 2.811-1.622.156-3.375zm1.923-1.11 3.154-1.822-.221 9.068-7.938 4.583-.021-3.34 5.028-2.902-.003-5.586zm-12.917 7.259 3.074 1.708 2.846-1.708v-5.75l4.896-3.017V11.19l-2.79-1.708-4.953 2.96-5.237-2.96-2.847 1.708v3.415l5.01 3.017v5.75zM16.207 31l-3.074-1.708v-3.415l3.074 1.594 2.846-1.593v3.415L16.207 31zm-5.237-8.767v-3.415l-2.847-1.65v3.244l2.847 1.821zm0 2.22v3.644l-7.742-4.725v-9.165l2.903 1.65v5.807l4.84 2.79z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbdown);
export default __webpack_public_path__ + "static/media/BNBDOWN.0ca8a165781e75ba54b81f918f58751e.svg";
export { ForwardRef as ReactComponent };